import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="sendmail">
                1.&nbsp;<span className="material-symbols-outlined">send</span>&nbsp;{translate('sendmail')}
            </Typography>
            <p><strong>{translate('sendmail')}</strong> is an action that sends an email using the Gmail API. This feature allows users to send emails from their Gmail account.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the <strong>Provider ID</strong> of the Gmail connection used to identify the email account (see <Box component={Link} to="/control-center/documentation/connections/gmail">here</Box> for connection creation).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('from')}</td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>The email sender's address. You can use addresses added to your account from Gmail settings (see at <a href='https://support.google.com/mail/answer/22370' target="_blank">here</a> for how to add them).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('to')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The address where the email will be sent.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('subject')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The subject of the email.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('body')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the content of the email.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('attachments')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the file path to attach to the email. You can also specify multiple files (comma-separated paths).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('cc')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the sending address in CC. You can also specify multiple addresses and named addresses.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('bcc')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the sending address in BCC. You can also specify multiple addresses and named addresses.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gmail-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('to')}</span>
                            <div>john.doe@example.com</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('subject')}</span>
                            <div>Hello! John!</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('body')}</span>
                            <div>Hi John, I'm very happy to send this mail to you.</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getgmail">
                2.&nbsp;<span className="material-symbols-outlined">mark_email_unread</span>&nbsp;{translate('getgmail')}
            </Typography>
            <p><strong>{translate('getgmail')}</strong> is an action that retrieves email from your Gmail for Google Workspace account.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$gmailMessages_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the <strong>Provider ID</strong> of the Gmail connection used to identify the email account (see <Box component={Link} to="/control-center/documentation/connections/gmail">here</Box> for connection creation).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('query')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>As a search condition (see <a href='https://support.google.com/mail/answer/7190' target="_blank">here</a> for details on search terms ).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('limit')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Is the maximum number of emails retrieved.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('markasread')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As an action to mark a message as read, if the <strong>{translate('markasread')}</strong> switch is enabled (true), all messages that match the search condition will be retrieved, and then marked as read.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$gmailMessages_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gmail-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('query')}</span>
                            <div>from: john.doe@example.com</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('markasread')}</span>
                            <div>true</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            {
                                                "id": "123456789abcdefg",
                                                "subject": "Hello! Me!",
                                                "to": "me <me@gmail.com>",
                                                "cc": "aaa <aaa@gmail.com>",
                                                "from": "bbb <bbb@gmail.com>",
                                                "date": "2023-01-14T10:41:09.000Z",
                                                "body": "Nice to meet you!",
                                                "html": "",
                                                "attachements": [
                                                {
                                                    "filename": "combine.pdf",
                                                    "contentType": "application/octet-stream",
                                                    "attachmentId": "ANGjdJ8xf--nLYOiblQaphB0PPmxwiHzqWb189HnjTBSsfYaIEDtgYj2ERCLNrDwMw_okMmC6yPCsip0rHRTvzwH7PbjuEd7TPE1mkYHPANdMCd0K8BU9kNEwR0AEKfw8JFPuHlxcTznvBBVlyjXfdMdjtrRSYRKPKwD-sqRZL0mleYM5TARSDLLKFVl0rhlMNFhvnFwUCLQPx_EmrHByTu2iZOQqDFLwF2gPuAvsvz3qc_ZmrCMs6A825NfRcniz0AzcNvDaCEEAMjbrif6hzOVqnaT1wBeBw-uRX9KxiFLquwuxW3-GI6oRROSG5QdzuzuvCUzcaK4vqxCaGzcDil0OjOOgbYBKCEZMXjKpGfeSq416VpQcj4t3YCaO0c8mfjP7MbwkHxmAS7wT8kGUSMI_0icEtmHKuQNwy3dgQ"
                                                },
                                                {
                                                    "filename": "image.png",
                                                    "contentType": "image/png",
                                                    "attachmentId": "ANGjdJ9A5SjcD6C0B3vB-DKy5bt7b8FxTPJpnAVwJ7KmtZ3bPRH8vYyM8XbWqUbNGLvGveHo0f4B0ucUiyTTV1zLRRQigFPTTHtdxE4rZodBQQjvQng3Fnyv82Z8H7rlyA2ST8eXP4sEvaWuJy16Gs8qS_QNVME86VLkSllif19xEwddOK3fM2WXmCG8A8kGdOl1W8xHpJ44wAVgzjxn1ah2VbxKbS-HEjx9n-kZ70rtlIKBlRl-5Nhr2MrifV4LtTvSx6Z-14Iw7RmECkB4PC6fHQk7CseD3z6x3aa4oRDygNeAwakSHbYq-FFajw1elYkCfG6b6t8sIEslCvNHERw8J3JiQfdcWE6QSoXkCSsp56xrkAsS4W__iQQ3hxR1iehbMu_h1rPTw4oANJ3R"
                                                }
                                                ]
                                            }
                                        ], null, 2)}
                                </pre>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="gmaildownloadattachments">
                3.&nbsp;<span className="material-symbols-outlined">attach_email</span>&nbsp;{translate('gmaildownloadattachments')}
            </Typography>
            <p><strong>{translate('gmaildownloadattachments')}</strong> is an action that downloads all files contained in the result of <strong>{translate('getgmail')}</strong> (the download is stored in the storage).</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$gmailAttachments_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the <strong>Provider ID</strong> of the Gmail connection used to identify the email account (see <Box component={Link} to="/control-center/documentation/connections/gmail">here</Box> for connection creation).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('gmailmessages')}<span>*</span></td>
                                <td>
                                    <div className='type-value'>
                                        <span className="material-symbols-outlined">data_array</span>
                                        <span>{translate('datatype__array')}</span>
                                    </div>
                                </td>
                                <td>As a result of <strong>{translate('getgmail')}</strong>.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$gmailAttachments_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>gmail-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('gmailmessages')}</span>
                            <div>$gmailMessages_1</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/combine.pdf",
                                            "/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/image.png",
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);